// extracted by mini-css-extract-plugin
export default {"formInputStatus":"Orderview_formInputStatus__vKwfO","titleH1":"Orderview_titleH1__HOEpp"};